import React from 'react';
import BottomNav from './BottomNav';

interface AppLayoutProps {
  children: React.ReactNode;
  showNav?: boolean;
}

export const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  showNav = true,
}) => {
  return (
    <div className="min-h-screen bg-slate-50">
      <main className={showNav ? 'pb-24 md:pb-8' : ''}>
        {children}
      </main>
      {showNav && <BottomNav />}
    </div>
  );
};

export default AppLayout;
